import { connect } from 'react-redux';
import idx from 'idx';
import { getInvoice } from 'project/ducks/project';
import { fetchMessagesIfNeeded } from 'common/ducks/message';
import PostFeedback from 'project/components/wrapup/post_feedback';

const mapStateToProps = (state) => {
  return {
    invoicePdf: idx(getInvoice(state), _ => _.pdf)
  };
}

export default connect(mapStateToProps, { fetchMessagesIfNeeded })(PostFeedback);



// WEBPACK FOOTER //
// ./project/containers/wrapup/post_feedback.js